/* istanbul ignore file */
import type { Decision } from '../constants';

const whenDecisionIs = (decision: Decision) => ({ $decision: { eq: decision } });

export default {
  decision: {
    type: 'string',
    required: true,
  },
  specialization: {
    type: 'string',
    required: {
      value: true,
      message: 'Please select the specialization',
    },
  },
  technology: {
    type: 'string',
    required: false,
  },
  level: {
    type: 'string',
    required: {
      value: true,
      message: 'Please select the level',
    },
  },
  nativeLanguage: {
    type: 'string',
    required: {
      value: true,
      when: whenDecisionIs('INTAKE'),
      message: 'Please select the native language',
    },
  },
  rejectionReason: {
    type: 'string',
    required: {
      value: true,
      when: whenDecisionIs('REJECT'),
      message: 'Please select the rejection reason',
    },
  },
  withdrawalReason: {
    type: 'string',
    required: {
      value: true,
      when: whenDecisionIs('WITHDRAWAL'),
      message: 'Please select the withdrawal reason',
    },
  },
};
